// Business rules and configuration constants
export const BUSINESS_RULES = {
  DISQUALIFICATION: {
    MINIMUM_TOTAL_SCORE: 0,
    MAX_MISSED_CLASSES: 2,
  },
  CALLOUT: {
    SPECIAL_CADET_NAME: "Tian Zhao", // Special case for odd number handling
    POINT_TRANSFER_RATIO: 0.5, // Transfer half of loser's points
  },
} as const;

export const CYCLE_PREFIXES: Record<string, string> = {
  c1: "C1",
  c2: "C2",
  c3: "C3",
  c4: "C4",
  c5: "C5",
};

export const EXCEL_HEADERS = {
  REQUIRED: ["Primary Cadet", "Rank", "Total"],
  CADET_INFO: {
    PRIMARY_CADET: "Primary Cadet",
    AGENT_CODE: "Agent Code",
    SPOUSE_PARTNER: "Spouse/Partner",
    SMD: "SMD",
    RANK: "Rank",
    QUALIFICATION: "Qualification",
    TOTAL: "Total",
  }
} as const;

export const UI_CONSTANTS = {
  LOADING_MESSAGES: {
    CALLOUT_DATA: "Loading callout data...",
    SCOREBOARD_DATA: "Loading scoreboard data...",
    EXCEL_PARSING: "Parsing Excel files...",
  },
  ERROR_MESSAGES: {
    FETCH_FAILED: "Failed to fetch data",
    PARSE_FAILED: "Failed to parse Excel file",
    VALIDATION_FAILED: "Data validation failed",
  }
} as const;

export const FILE_PATHS = {
  EXCEL: {
    C0_SCOREBOARD: "/c0-scoreboard.xlsx",
    C1_SCOREBOARD: "/c1-scoreboard.xlsx",
    C2_SCOREBOARD: "/c2-scoreboard.xlsx", 
    C3_SCOREBOARD_BEFORE_CALLOUT: "/c3-scoreboard-before-callout.xlsx",
    C3_SCOREBOARD_AFTER_CALLOUT: "/c3-scoreboard-after-callout.xlsx",
    C4_SCOREBOARD_BEFORE_CALLOUT: "/c4-scoreboard-before-callout.xlsx",
    C4_SCOREBOARD_AFTER_CALLOUT: "/c4-scoreboard-after-callout.xlsx",
    C5_SCOREBOARD_BEFORE_CALLOUT: "/c5-scoreboard-before-callout.xlsx",
  }
} as const;
